import React from 'react';
import { Box } from '@components/Box';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import ReactHtmlParser from 'react-html-parser';

import {
  HeroTextWrapper,
  StyledBox,
  StyledButton,
  StyledTextPairing,
  HeroBox,
  HeroCloudImage,
  LeftBox,
  RightBox,
  RightCurlBox,
  YellowCircleCloudImage,
  SideCloudImage,
  StyledText,
  StyledTextCollect,
  StyledFlex,
  IconCloudImage,
  StyledCloudImage,
} from './GuestListMobileHeroSection.styles';
import { useTranslation } from 'react-i18next';

export const GuestListMobileHeroSection: React.FC = () => {
  const { t } = useTranslation('guestList');
  const connectedGuestListData = t('connectedGuestList');

  return (
    <Box id="Guest_List_Hero_Mobile" marginX="auto" backgroundColor={'yellow1'}>
      <HeroTextWrapper>
        <StyledTextPairing
          title={connectedGuestListData.title}
          titleColor="neutra6"
          titleVariant="hed56"
          titleTagName="h1"
          body={connectedGuestListData.content}
          bodyColor="neutra5"
          bodyVariant="dek24"
          marginTop={[10, 4]}
          alignment="center"
        />
        <StyledBox marginTop={8}>
          <StyledButton id="ConnectedGuestListMobile" variant="secondary" forwardedAs="a" href={getCreateWeddingUrl('guest-list')}>
            {connectedGuestListData.button}
          </StyledButton>
        </StyledBox>
      </HeroTextWrapper>
      <HeroBox>
        <HeroCloudImage isEagerLoading={true} src={'guest-list/hero/mobile/hero.png'} optimization={'mild'} />
      </HeroBox>
      <LeftBox>
        <SideCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/circle.svg'}
          optimization={'mild'}
          mobileResizeWidth={38}
          width={38}
          reswidth={190}
        />
      </LeftBox>
      <StyledFlex alignItems={'center'} flexDirection={'column'} marginTop={13} marginBottom={-7}>
        <IconCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/icon-group.svg'}
          mobileResizeWidth={62}
          optimization={'mild'}
          width="15%"
          height="14.5%"
        />
        <StyledText color="neutra6" variant="hed40" tagName="h3" textAlign={'center'} marginTop={3}>
          {ReactHtmlParser(t('animationValueProps.group'))}
        </StyledText>
        <StyledCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/group.png?'}
          width={'30%'}
          top={45}
          left={33}
          optimization={'mild'}
        />
      </StyledFlex>
      <RightBox>
        <YellowCircleCloudImage isEagerLoading={true} src={'guest-list/hero/mobile/yellow-circle-v2.png'} />
      </RightBox>
      <StyledFlex alignItems={'center'} flexDirection={'column'} marginTop={'17rem'} marginBottom={7}>
        <IconCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/icon-tag.svg'}
          optimization={'mild'}
          width="15%"
          height="14.5%"
        />
        <StyledText color="neutra6" variant="hed40" tagName="h3" textAlign={'center'} marginTop={3}>
          {ReactHtmlParser(t('animationValueProps.organize'))}
        </StyledText>
        <StyledCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/organize.png'}
          width={'70%'}
          top={45}
          left={16}
          optimization={'mild'}
        />
      </StyledFlex>
      <LeftBox>
        <SideCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/grid.svg'}
          mobileResizeWidth={155}
          width={155}
          optimization={'mild'}
          reswidth={180}
        />
      </LeftBox>
      <StyledFlex alignItems={'center'} flexDirection={'column'} marginTop={'15rem'} marginBottom={7}>
        <IconCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/icon-plane.svg'}
          optimization={'mild'}
          width="15%"
          height="14.5%"
        />
        <StyledText color="neutra6" variant="hed40" tagName="h3" textAlign={'center'} marginTop={3}>
          {ReactHtmlParser(t('animationValueProps.invite'))}
        </StyledText>
        <StyledCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/send.png'}
          width={'75%'}
          top={45}
          left={19}
          optimization={'mild'}
        />
      </StyledFlex>
      <RightCurlBox>
        <SideCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/curl.svg'}
          mobileResizeWidth={162}
          width={162}
          optimization={'mild'}
          reswidth={173}
        />
      </RightCurlBox>
      <StyledFlex alignItems={'center'} flexDirection={'column'} marginTop={'18rem'} marginBottom={-3}>
        <IconCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/icon-graph.svg'}
          optimization={'mild'}
          width="15%"
          height="14.5%"
        />
        <StyledTextCollect color="neutra6" variant="hed40" tagName="h3" textAlign={'center'} marginTop={3}>
          {ReactHtmlParser(t('animationValueProps.track'))}
        </StyledTextCollect>
        <StyledCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/collect.png'}
          width={'30%'}
          top={45}
          left={37}
          optimization={'mild'}
        />
      </StyledFlex>
      <Box>
        <SideCloudImage
          isEagerLoading={true}
          src={'guest-list/hero/mobile/burst.svg'}
          mobileResizeWidth={172}
          width={172}
          optimization={'mild'}
          reswidth={45}
        />
      </Box>
    </Box>
  );
};
